export const APP_INIT = 'APP_INIT';
export const APP_AUTHENTICATED = 'APP_AUTHENTICATED';
export const APP_ERROR = 'APP_ERROR';
export const APP_RUNTIME_INITIALIZED = 'APP_RUNTIME_INITIALIZED';
export const APP_SCRIPTS_LOADED = 'APP_SCRIPTS_LOADED';
export const APP_WARP = 'APP_WARP';
export const APP_KEYDOWN = 'APP_KEYDOWN';
export const APP_KEYUP = 'APP_KEYUP';
export const APP_OVERRIDE_SUPPORTED_BROWSER = 'APP_OVERRIDE_SUPPORTED_BROWSER';
export const APP_LOADED_SITECODE = 'APP_LOADED_SITECODE';
export const APP_USER_PRODUCTS = 'APP_USER_PRODUCTS';
export const APP_PRODUCT_SELECTED = 'APP_PRODUCT_SELECTED';
export const APP_SELECTED_PRODUCT = 'APP_SELECTED_PRODUCT';
export const APP_CLEARED_PRODUCT = 'APP_CLEARED_PRODUCT';
export const APP_STUDENT_NAME = 'APP_STUDENT_NAME';
export const APP_STUDENT_SITECODE = 'APP_STUDENT_SITECODE';
export const APP_VERSION_RECEIVED = 'APP_VERSION_RECEIVED';
export const APP_IDENTITY_CONFIRMED = 'APP_IDENTITY_CONFIRMED';
export const APP_IDENTITY_DENIED = 'APP_IDENTITY_DENIED';
export const APP_STASH_QUERY_PARAMS = 'APP_STASH_QUERY_PARAMS';
export const APP_APPLY_STORED_QUERY_PARAMS = 'APP_APPLY_STORED_QUERY_PARAMS';
export const APP_CLEAR_STORED_QUERY_PARAMS = 'APP_CLEAR_STORED_QUERY_PARAMS';
export const APP_AUTHTYPE_SET = 'APP_AUTHTYPE_SET';

export const FORM_INIT = 'FORM_INIT';
export const FORM_UPDATE_SITECODE = 'FORM_UPDATE_SITECODE';
export const FORM_ERROR = 'FORM_ERROR';
export const FORM_CLEAR_ERROR = 'FORM_CLEAR_ERROR';
export const FORM_DIRTY_ALL_FIELDS = 'FORM_DIRTY_ALL_FIELDS';
export const FORM_FIELD_INVALID = 'FORM_FIELD_INVALID';
export const FORM_FIELD_VALUE_CHANGED = 'FORM_FIELD_VALUE_CHANGED';
export const FORM_EDIT_SITECODE = 'FORM_EDIT_SITECODE';
export const FORM_REVERT_SITECODE = 'FORM_REVERT_SITECODE';

export const NETWORKHEALTH_ENABLED = 'NETWORKHEALTH_ENABLED';
export const NETWORKHEALTH_API_LATENCY_ERROR = 'NETWORKHEALTH_API_LATENCY_ERROR';
export const NETWORKHEALTH_API_LATENCY_LOADING = 'NETWORKHEALTH_API_LATENCY_LOADING';
export const NETWORKHEALTH_UPDATE_API_LATENCY = 'NETWORKHEALTH_UPDATE_API_LATENCY';
export const NETWORKHEALTH_UPDATE_SPEED_TEST = 'NETWORKHEALTH_UPDATE_SPEED_TEST';
export const NETWORKHEALTH_SPEED_TEST_START = 'NETWORKHEALTH_SPEED_TEST_START';
export const NETWORKHEALTH_SPEED_TEST_COMPLETE = 'NETWORKHEALTH_SPEED_TEST_COMPLETE';
export const NETWORKHEALTH_SPEED_TEST_ERROR = 'NETWORKHEALTH_SPEED_TEST_ERROR';
export const NETWORKHEALTH_INCLUDE_MEDIA_BOOSTERS = 'NETWORKHEALTH_INCLUDE_MEDIA_BOOSTERS';
export const NETWORKHEALTH_ADD_SERVICES = 'NETWORKHEALTH_ADD_SERVICES';
export const NETWORKHEALTH_REMOVE_SERVICES = 'NETWORKHEALTH_REMOVE_SERVICES';

export const SSO_AUTHENTICATION_COMPLETE = 'SSO_AUTHENTICATION_COMPLETE';
export const SSO_ERROR = 'SSO_ERROR';

export const WEBCAM_ERROR_OCCURRED = 'WEBCAM_ERROR_OCCURRED';
export const WEBCAM_LOADED = 'WEBCAM_LOADED';
export const WEBCAM_CLOSED = 'WEBCAM_CLOSED';
export const WEBCAM_CAMERA_CHANGED = 'WEBCAM_CAMERA_CHANGED';
export const WEBCAM_CAMERAS_ENUMERATED = 'WEBCAM_CAMERAS_ENUMERATED';

export const STARTING_UNITY_PLAYER_LOAD = "STARTING_UNITY_PLAYER_LOAD";



// WEBPACK FOOTER //
// ./src/constants/actions.js